<template>
  <div style="width: 560px;">
    <a-alert :show-icon="true" type="warning">
      <div slot="message">
        <div>* 添加用户为本相册的摄影师，即有权限上传照片到本相册</div>
        <div>* 添加人数不限，每个摄影师仅有查看自己上传照片的权限</div>
        <div>* 当前仅能添加一位修图师，可下载并回传需要修图的照片</div>
      </div>
    </a-alert>
    <a-spin :spinning="searching">
      <MemberItems :data="graphers" :role="role.Grapher" :album="album" @refresh="refresh" :addible="true"/>
      <a-divider style="height: 0; margin-bottom: 60px;"/>
      <MemberItems :data="retouchers" :role="role.Retoucher" :album="album"
                   @refresh="refresh" :addible="!retouchers.length"/>
    </a-spin>
  </div>
</template>

<script>
import cache from "../../../../utils/cache";
import enums from "../../../../utils/enums";
import MemberItems from "./comps/MemberItems";

export default {
  name: "Member",
  components: {MemberItems},
  props: {album: Object},
  data() {
    return {
      role: enums.Role,
      searching: false,
      result: {total: 0, data: []},
    }
  },
  mounted() {
    this.refresh();
  },
  computed: {
    graphers() {
      return this.result.data.filter(item => {
        return enums.Role.isGrapher(item["roles"]);
      })
    },
    retouchers() {
      return this.result.data.filter(item => {
        return enums.Role.isRetoucher(item["roles"]);
      })
    }
  },
  methods: {
    refresh() {
      this.searching = true;
      cache.v1.album.member.search(this.album.id)
          .then(res => this.result = res)
          .finally(() => this.searching = false);
    }
  }
}
</script>
